import { render } from "./Carousel.vue?vue&type=template&id=3795989b&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=3795989b&lang=less&scoped=true"

import exportComponent from "E:\\project\\eyes-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3795989b"]])

export default __exports__